module.exports = {"TXTWCL_Need_more_N0_helpX":{"id":"TXTWCL_Need_more_N0_helpX","defaultMessage":"Benötigen Sie weitere Hilfe zum Thema {0}?"}}